import React from 'react';
import clsx from 'clsx';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}

export const Input: React.FC<InputProps> = ({
  label,
  error,
  className,
  id,
  ...props
}) => {
  const inputId = id || label?.toLowerCase().replace(/\s+/g, '-');
  
  return (
    <div className="w-full">
      {label && (
        <label
          htmlFor={inputId}
          className="block text-sm font-semibold text-brand-blue mb-2"
        >
          {label}
        </label>
      )}
      <input
        id={inputId}
        className={clsx(
          'w-full px-4 py-3 border rounded-lg transition-colors',
          'focus:ring-2 focus:ring-brand-blue focus:border-transparent',
          error ? 'border-brand-red' : 'border-gray-300',
          className
        )}
        {...props}
      />
      {error && (
        <p className="text-brand-red text-sm mt-1">{error}</p>
      )}
    </div>
  );
};

